import React from 'react';
import { Reveal } from './Reveal';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  role: string;
};
const testimonials: Testimonial[] = [{
  initials: 'SR',
  quote: 'I planned my entire month of step classes in one Sunday afternoon. I walked into class Monday morning knowing exactly what to do, which patterns to teach, and how to correct every mistake. My students felt the difference immediately.',
  name: 'Sarah R.',
  role: 'Los Angeles, CA · Step & Group Fitness Instructor'
}, {
  initials: 'JM',
  quote: 'I had a student with knee issues and honestly didn’t know how to adapt the class safely. Volume 4 gave me the exact low-impact protocols. Now I handle every modification with complete confidence and zero hesitation.',
  name: 'Jessica M.',
  role: 'Austin, TX · Step & Cardio Instructor'
}, {
  initials: 'KP',
  quote: 'I used to spend hours every week searching for choreography ideas. Now I open the drill bank, choose the sequence, print the sheet, and I’m done in 5 minutes. It completely changed how I prepare for class.',
  name: 'Karen P.',
  role: 'London, UK · Group Fitness & Step Instructor'
}];
export function TestimonialStrip() {
  return <section className="w-full bg-surface px-4 py-20 sm:py-24" data-id="element-217" data-mp="2078rda7egfms">
      <div className="mx-auto max-w-6xl" data-id="element-218" data-mp="208jtz6p3zhcb">
        <Reveal className="text-center" data-id="element-219" data-mp="1vfqmwc663wx2">
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl" data-id="element-220" data-mp="1vep9w25ld0cp">
            ⭐ What Instructors Are <span className="text-green-dark" data-id="element-221" data-mp="255tsrcye15ct">Saying</span>
          </h2>
          <p className="mt-4 text-slate" data-id="element-222" data-mp="255k1zn5iqu62">Professionals who now teach every step class with a real system.</p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-223" data-mp="2e6i605fyj1on">
          {testimonials.map((item, index) => <Reveal key={item.initials} delay={index * 0.05} data-id="element-224" data-mp="2e4ouocueftab" data-mpi={index}>
              <figure className="flex h-full flex-col rounded-2xl border border-ink/10 bg-mist p-8 shadow-premium" data-id="element-225" data-mp="os3l5w827yyf">
                <div className="text-green" data-id="element-226" data-mp="julaa0ahf9ns">★★★★★</div>
                <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-227" data-mp="2jvi6406fpgot">“{item.quote}”</blockquote>
                <figcaption className="mt-7 flex items-center gap-3" data-id="element-228" data-mp="2ouus6iphejqc">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-sky text-sm font-bold text-teal" data-id="element-229" data-mp="2suwtgqrb1b53">
                    {item.initials}
                  </span>
                  <span data-id="element-230" data-mp="32tudphhp6iia">
                    <span className="block font-bold text-ink" data-id="element-231" data-mp="32udu2trp8yu7">{item.name}</span>
                    <span className="mt-0.5 block text-xs text-slate" data-id="element-232" data-mp="37s5nxtbwmv11">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}